import { FormLabelPosition, Textarea } from '@dreryk/react-components';

import { prescriptionTranslationKeys } from '../../../../../../../translations';
import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

type PatientInstructionFieldProps = Pick<ExtendedDosageFormController, 'register'> & {
   readonly defaultValue: string | null;
};

export const PatientInstructionField = (props: PatientInstructionFieldProps): JSX.Element => {
   return (
      <Textarea
         testId={'patientInstruction'}
         controller={props.register('patientInstruction')}
         defaultValue={props.defaultValue}
         label={prescriptionTranslationKeys.extendedDosage.dsLabel}
         labelPosition={FormLabelPosition.TOP}
         placeholder={prescriptionTranslationKeys.extendedDosage.dsPlaceholder}
         withoutRequiredMark
         focus={false}
         rows={2}
         maxRows={6}
         compact
      />
   );
};
